"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfActivityInfoSearchModel = instanceOfActivityInfoSearchModel;
exports.ActivityInfoSearchModelFromJSON = ActivityInfoSearchModelFromJSON;
exports.ActivityInfoSearchModelFromJSONTyped = ActivityInfoSearchModelFromJSONTyped;
exports.ActivityInfoSearchModelToJSON = ActivityInfoSearchModelToJSON;
exports.ActivityInfoSearchModelToJSONTyped = ActivityInfoSearchModelToJSONTyped;
/**
 * Check if a given object implements the ActivityInfoSearchModel interface.
 */
function instanceOfActivityInfoSearchModel(value) {
    return true;
}
function ActivityInfoSearchModelFromJSON(json) {
    return ActivityInfoSearchModelFromJSONTyped(json, false);
}
function ActivityInfoSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'subjectName': json['subjectName'] == null ? undefined : json['subjectName'],
        'content': json['content'] == null ? undefined : json['content'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
function ActivityInfoSearchModelToJSON(json) {
    return ActivityInfoSearchModelToJSONTyped(json, false);
}
function ActivityInfoSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'subjectName': value['subjectName'],
        'content': value['content'],
        'active': value['active'],
    };
}
